<template>
    <div class="bodyLoader d-flex flex-column">
        <img src="/img/brand/logo_new_loading.svg" alt="logo-conectados">
        <div class="progress-loading mt-3"></div>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                default: 'Estamos preparando tu contenido',
            },
        },
        mounted() {
        }
    }
</script>

<style>
    .bodyLoader{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background: #fff;
        z-index: 100000;
        min-height: 100vh !important;
    }
    .bodyLoader img{
        width: 170px !important;
    }
    .loaderVue{
        position: relative;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background: linear-gradient(#204F9A, #59CBE8, #8c8cd8);
        animation: animate 0.8s linear infinite;
    }
    @keyframes animate
    {
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }

    .loaderVue span{
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: linear-gradient(#204F9A, #59CBE8, #8c8cd8);
    }

    .loaderVue span:nth-child(1){
        filter: blur(5px);
    }

    .loaderVue span:nth-child(2){
        filter: blur(10px);
    }

    .loaderVue span:nth-child(3){
        filter: blur(10px);
    }

    .loaderVue span:nth-child(4){
        filter: blur(10px);
    }

    .loaderVue:after{
        content: '';
        position: absolute;
        top: 10px;
        left: 10px;
        right: 10px;
        bottom: 10px;
        background: #e2e8f6c2;
        border-radius: 50%;
    }

    .progress-loading {
        width: 90px;
        height: 10px;
        -webkit-mask: radial-gradient(circle closest-side,#caa2e7 94%,#0000) left/20% 100%;
        background: linear-gradient(#caa2e7 0 0) left/0% 100% no-repeat #5A1E85;
        animation: progress-c3ir73 1s infinite linear;
    }

    @keyframes progress-c3ir73 {
        100% {
            background-size: 120% 100%;
        }
    }


</style>
